import { NextWorkflowError } from 'models/NextWorkflowError';
import type { Collection } from 'state/utils/types';

export type DlpOrderStatus = 'NOT_READY' | 'READY' | 'ORDER_PENDING' | 'ORDER_PLACED' | 'ORDER_FAILED' | 'ORDER_STALE';

export type OrderState = {
  orderId?: string;
  status?: 'PENDING' | 'DONE' | 'REJECTED' | 'STALE';
  errorMessage?: string;
  timeout?: number;
  isTimeout?: boolean;
  execTime?: string;
  rejections?: readonly NextWorkflowError[];
};

export type OrderStateMap = Collection<OrderState>;

export const initialOrderState: OrderState = {};

export const initialOrderMap = {};
